import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/aiImage/reducers'
import { getInitialState } from 'store/features/aiImage/initialState'

const aiImageSlice = createSlice({
  name: 'aiImage',
  initialState: getInitialState(),
  reducers
})

export default aiImageSlice
